import React from 'react';
import {Helmet} from 'react-helmet-async';
import {Link} from 'react-router-dom';
import {motion} from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiCheck,FiArrowRight,FiShoppingCart,FiCreditCard,FiTrendingUp,FiShield,FiUsers,FiSettings,FiCalendar}=FiIcons;

const Ecommerce=()=> {
  const packages=[
    {
      name: "E-commerce Base",
      price: "a partire da €1.490",
      description: "Perfetto per iniziare a vendere online",
      features: [
        "Fino a 10 prodotti",
        "Design responsive mobile-first",
        "Pagamenti Stripe/PayPal",
        "Gestione ordini base",
        "SSL e sicurezza",
        "Hosting 1 anno incluso"
      ],
      popular: false
    },
    {
      name: "E-commerce Pro",
      price: "a partire da €2.490",
      description: "Soluzione completa per PMI",
      features: [
        "Fino a 50 prodotti caricati in chiave SEO dai nostri esperti",
        "Prodotti illimitati con nostra guida e assistenza",
        "Gestione magazzino avanzata",
        "Multi-pagamento e fatturazione",
        "Analytics e-commerce",
        "Email marketing integrato",
        "Assistenza 12 mesi"
      ],
      popular: true
    },
    {
      name: "E-commerce Enterprise",
      price: "a partire da €4.990",
      description: "Per aziende che puntano in alto",
      features: [
        "Caricamento fino a 100 prodotti in chiave SEO dai nostri esperti",
        "Prodotti illimitati con nostra guida e assistenza",
        "Multi-store e multilingua",
        "Automazioni avanzate",
        "Marketplace integration",
        "Analytics e-commerce",
        "Gestione magazzino avanzata",
        "Multi-pagamento e fatturazione",
        "Email marketing integrato",
        "Ottimizzazione SEO per un anno con report mensili",
        "Assistenza dedicata avanzata 12 mesi"
      ],
      popular: false
    }
  ];

  const features=[
    {
      icon: FiShoppingCart,
      title: "Catalogo Prodotti",
      description: "Gestione semplice di categorie,varianti,scorte e prezzi"
    },
    {
      icon: FiCreditCard,
      title: "Pagamenti Sicuri",
      description: "Stripe,PayPal,bonifico e contrassegno integrati"
    },
    {
      icon: FiTrendingUp,
      title: "Analytics Vendite",
      description: "Monitoraggio performance,conversioni e ROI in tempo reale"
    },
    {
      icon: FiShield,
      title: "Sicurezza Totale",
      description: "SSL,backup automatici e conformità GDPR garantita"
    }
  ];

  const faq=[
    {
      question: "Quanto tempo serve per realizzare un e-commerce?",
      answer: "Dipende dalla complessità: 15-30 giorni per un e-commerce base,30-60 giorni per soluzioni più articolate con integrazioni personalizzate."
    },
    {
      question: "Quali sistemi di pagamento supportate?",
      answer: "Integriamo Stripe,PayPal,bonifico bancario,contrassegno e carte di credito. Possiamo aggiungere altri gateway su richiesta."
    },
    {
      question: "Posso gestire autonomamente prodotti e ordini?",
      answer: "Assolutamente sì. Utilizziamo WooCommerce o Shopify che permettono gestione completa e intuitiva. Ti formiamo gratuitamente."
    },
    {
      question: "L'e-commerce sarà ottimizzato per mobile?",
      answer: "Sì,tutti i nostri e-commerce sono mobile-first. Il 70% degli acquisti online avviene da smartphone,per questo è fondamentale."
    },
    {
      question: "Cosa include il supporto post-lancio?",
      answer: "Assistenza tecnica,aggiornamenti sicurezza,backup,monitoraggio uptime e supporto per modifiche e nuove funzionalità."
    }
  ];

  return (
    <>
      <Helmet>
        <title>Realizzazione E-commerce Napoli – Shop Online che Convertono</title>
        <meta name="description" content="E-commerce a Napoli: UX ottimizzata,pagamenti sicuri,SEO e automazioni. Aumenta le vendite online. Preventivo gratuito per il tuo shop." />
        <meta name="keywords" content="realizzazione e-commerce napoli,shop online napoli,woocommerce napoli,shopify napoli,vendere online napoli" />
        <link rel="canonical" href="https://realizzazionesitiweb-napoli.it/servizi/realizzazione-ecommerce-napoli" />
      </Helmet>

      {/* Hero Section - Velo scuro al 40% */}
      <section className="relative min-h-screen bg-napoli-gradient text-white overflow-hidden flex items-center">
        <div className="absolute inset-0"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?q=80&w=1920&auto=format&fit=crop')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        ></div>
        <div className="absolute inset-0 bg-black opacity-40"></div>
        
        <div className="relative container mx-auto px-4 py-20">
          <div className="max-w-4xl mx-auto text-center">
            <motion.h1 style={{
      paddingTop: '40px',
      paddingBottom: '40px'
    }}
              initial={{opacity: 0,y: 30}}
              animate={{opacity: 1,y: 0}}
              className="text-4xl lg:text-5xl font-poppins font-bold mb-6 text-contrast-white"
            >E-commerce a Napoli che Vendono Davvero</motion.h1>
            
            <motion.p
              initial={{opacity: 0,y: 30}}
              animate={{opacity: 1,y: 0}}
              transition={{delay: 0.2}}
              className="text-xl mb-8 text-contrast-white leading-relaxed"
            >
              Shop online completi con UX ottimizzata,pagamenti sicuri e automazioni per aumentare le vendite. Perfetti per PMI e aziende di Napoli che vogliono crescere nel digitale.
            </motion.p>
            
            <motion.div
              initial={{opacity: 0,y: 30}}
              animate={{opacity: 1,y: 0}}
              transition={{delay: 0.4}}
              className="flex flex-col sm:flex-row gap-4 justify-center"
            >
              <Link
                to="/contatti"
                className="bg-napoli-accent hover:bg-yellow-400 text-napoli-blu font-bold py-4 px-8 rounded-xl transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-napoli-accent focus:ring-opacity-50 shadow-lg hover:shadow-xl text-lg"
              >
                Preventivo gratuito in 24h
              </Link>
              <a
                href="https://tidycal.com/sitiwebstudio/consulenza-siti-web-napoli"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-napoli-azzurro hover:bg-blue-500 text-white font-bold py-4 px-8 rounded-xl transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-napoli-azzurro focus:ring-opacity-50 shadow-lg hover:shadow-xl text-lg"
              >
                <SafeIcon icon={FiCalendar} className="w-5 h-5 mr-2 inline" />
                Prenota una consulenza
              </a>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-poppins font-bold text-napoli-blu mb-6">
              Tutto quello che serve per vendere online
            </h2>
            <p className="text-xl text-napoli-blu font-medium">
              Funzionalità complete per gestire il tuo business e-commerce
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature,index)=> (
              <motion.div
                key={index}
                initial={{opacity: 0,y: 30}}
                whileInView={{opacity: 1,y: 0}}
                transition={{duration: 0.6,delay: index * 0.1}}
                viewport={{once: true}}
                className="text-center"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-napoli-azzurro to-napoli-accent rounded-lg flex items-center justify-center mx-auto mb-4">
                  <SafeIcon icon={feature.icon} className="w-8 h-8 text-napoli-blu" />
                </div>
                <h3 className="text-xl font-poppins font-semibold text-napoli-blu mb-3">{feature.title}</h3>
                <p className="text-napoli-blu leading-relaxed font-medium">{feature.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Packages Section */}
      <section className="py-20 bg-napoli-light">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-poppins font-bold text-napoli-blu mb-6">
              Pacchetti e-commerce per ogni business
            </h2>
            <p className="text-xl text-napoli-blu font-medium">
              Dal primo shop online alla soluzione enterprise
            </p>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {packages.map((pkg,index)=> (
              <motion.div
                key={index}
                initial={{opacity: 0,y: 30}}
                whileInView={{opacity: 1,y: 0}}
                transition={{duration: 0.6,delay: index * 0.1}}
                viewport={{once: true}}
                className={`bg-white rounded-xl p-8 shadow-lg relative ${pkg.popular ? 'border-2 border-napoli-accent' : ''}`}
              >
                {pkg.popular && (
                  <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                    <span className="bg-napoli-accent text-napoli-blu px-4 py-2 rounded-full text-sm font-semibold">
                      Più venduto
                    </span>
                  </div>
                )}
                
                <div className="text-center mb-6">
                  <h3 className="text-2xl font-poppins font-bold text-napoli-blu mb-2">{pkg.name}</h3>
                  <div className="text-3xl font-bold text-napoli-azzurro mb-2">{pkg.price}</div>
                  <p className="text-napoli-blu font-medium">{pkg.description}</p>
                </div>
                
                <ul className="space-y-3 mb-8">
                  {pkg.features.map((feature,idx)=> (
                    <li key={idx} className="flex items-start">
                      <SafeIcon icon={FiCheck} className="w-5 h-5 text-napoli-accent mr-3 flex-shrink-0 mt-0.5" />
                      <span className="text-napoli-blu font-medium">{feature}</span>
                    </li>
                  ))}
                </ul>
                
                <Link
                  to="/contatti"
                  className={`block w-full text-center py-3 px-6 rounded-lg font-semibold transition-all ${
                    pkg.popular ? 'bg-napoli-accent text-napoli-blu hover:bg-yellow-400' : 'bg-napoli-azzurro text-white hover:bg-napoli-blu'
                  }`}
                >
                  Richiedi preventivo
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-3xl lg:text-4xl font-poppins font-bold text-napoli-blu mb-6">
                Domande frequenti sugli e-commerce
              </h2>
            </div>
            
            <div className="space-y-6">
              {faq.map((item,index)=> (
                <motion.div
                  key={index}
                  initial={{opacity: 0,y: 20}}
                  whileInView={{opacity: 1,y: 0}}
                  transition={{duration: 0.6,delay: index * 0.1}}
                  viewport={{once: true}}
                  className="bg-napoli-light rounded-lg p-6"
                >
                  <h3 className="text-lg font-semibold text-napoli-blu mb-3">{item.question}</h3>
                  <p className="text-napoli-blu leading-relaxed font-medium">{item.answer}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section - Velo scuro al 40% */}
      <section className="relative py-20 overflow-hidden">
        <div className="absolute inset-0"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?q=80&w=1920&auto=format&fit=crop')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        ></div>
        <div className="absolute inset-0 bg-black opacity-40"></div>
        
        <div className="relative container mx-auto px-4 text-center">
          <h2 className="text-3xl lg:text-4xl font-poppins font-bold mb-6 text-white drop-shadow-lg">
            Inizia a vendere online oggi stesso
          </h2>
          <p className="text-xl mb-8 text-white max-w-2xl mx-auto font-medium drop-shadow-md">
            Trasforma la tua attività con un e-commerce professionale. Analisi gratuita del tuo progetto e preventivo in 24 ore.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contatti"
              className="bg-napoli-accent hover:bg-yellow-400 text-napoli-blu font-bold py-4 px-8 rounded-xl transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-napoli-accent focus:ring-opacity-50 shadow-lg hover:shadow-xl text-lg"
            >
              Preventivo gratuito in 24h
            </Link>
            <a
              href="https://tidycal.com/sitiwebstudio/consulenza-siti-web-napoli"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-napoli-azzurro hover:bg-blue-500 text-white font-bold py-4 px-8 rounded-xl transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-napoli-azzurro focus:ring-opacity-50 shadow-lg hover:shadow-xl text-lg"
            >
              <SafeIcon icon={FiCalendar} className="w-5 h-5 mr-2 inline" />
              Prenota una consulenza
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Ecommerce;